import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _sortBy from "lodash/sortBy";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isTool } from '../types/recipe';
export var fetchAllRecipes = function fetchAllRecipes(client, options) {
  return client.get("/content/entries/recipe", options).then(function (res) {
    var transformedResponse = res.map(function (recipe) {
      var _recipe$authors, _recipe$ogImage, _recipe$ogImage2, _recipe$requiredTools, _recipe$useCases;

      return _objectSpread(_objectSpread({}, recipe), {}, {
        authors: (_recipe$authors = recipe.authors) === null || _recipe$authors === void 0 ? void 0 : _recipe$authors.map(function (author) {
          var _author$fields$headsh, _author$fields$headsh2, _author$fields$compan, _author$fields$compan2;

          return _objectSpread(_objectSpread({}, author.fields), {}, {
            headshot: {
              title: author.fields.headshot.fields.title,
              src: author.fields.headshot.fields.file.url,
              width: (_author$fields$headsh = author.fields.headshot.fields.file.details.image) === null || _author$fields$headsh === void 0 ? void 0 : _author$fields$headsh.width,
              height: (_author$fields$headsh2 = author.fields.headshot.fields.file.details.image) === null || _author$fields$headsh2 === void 0 ? void 0 : _author$fields$headsh2.height
            },
            companyLogo: {
              title: (_author$fields$compan = author.fields.companyLogo) === null || _author$fields$compan === void 0 ? void 0 : _author$fields$compan.fields.title,
              src: (_author$fields$compan2 = author.fields.companyLogo) === null || _author$fields$compan2 === void 0 ? void 0 : _author$fields$compan2.fields.file.url
            }
          });
        }),
        ogImage: {
          src: (_recipe$ogImage = recipe.ogImage) === null || _recipe$ogImage === void 0 ? void 0 : _recipe$ogImage.fields.file.url,
          title: (_recipe$ogImage2 = recipe.ogImage) === null || _recipe$ogImage2 === void 0 ? void 0 : _recipe$ogImage2.fields.title
        },
        requiredTools: (_recipe$requiredTools = recipe.requiredTools) === null || _recipe$requiredTools === void 0 ? void 0 : _recipe$requiredTools.map(function (tool) {
          return tool.fields;
        }),
        useCases: (_recipe$useCases = recipe.useCases) === null || _recipe$useCases === void 0 ? void 0 : _recipe$useCases.map(function (useCase) {
          return useCase.fields;
        })
      });
    });
    return _sortBy(transformedResponse, function (item) {
      return item.title;
    });
  });
};
export var fetchFeaturedRecipes = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var client, _ref$max, max, options, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = _ref.client, _ref$max = _ref.max, max = _ref$max === void 0 ? 3 : _ref$max, options = _ref.options;
            _context.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            data = _context.sent.filter(function (item) {
              return item.featured;
            }).slice(0, max);
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFeaturedRecipes(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchRecipe = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var client, options, slug, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            client = _ref3.client, options = _ref3.options, slug = _ref3.slug;
            _context2.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            data = _context2.sent.find(function (item) {
              return item.slug === slug;
            });
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchRecipe(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
export var fetchFilters = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
    var client, filtersObjs, options, allRecipes, filters;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            client = _ref5.client, filtersObjs = _ref5.filtersObjs, options = _ref5.options;
            _context3.next = 3;
            return fetchAllRecipes(client, options);

          case 3:
            allRecipes = _context3.sent;
            filters = filtersObjs.map(function (_ref7) {
              var id = _ref7.id,
                  displayName = _ref7.displayName,
                  searchableId = _ref7.searchableId;
              var options = allRecipes.reduce(function (acc, recipe) {
                if (recipe[id]) {
                  var value = recipe[id];
                  if (typeof value === "string") acc.push(value);else if (Array.isArray(value) && value.some(function (el) {
                    return typeof el === "object" && isTool(el);
                  })) value.map(function (el) {
                    return acc.push(el.name);
                  });else if (Array.isArray(value)) acc.push.apply(acc, _toConsumableArray(value));else {
                    throw new Error("Unexpected value type for filter ".concat(id));
                  }
                }

                return acc;
              }, []);
              return {
                id: id,
                searchableId: searchableId,
                displayName: displayName,
                options: _sortBy(Array.from(new Set(options)).map(function (option) {
                  return {
                    value: option,
                    text: option
                  };
                }), function (opt) {
                  return opt.value.toLowerCase();
                })
              };
            });
            return _context3.abrupt("return", filters);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchFilters(_x3) {
    return _ref6.apply(this, arguments);
  };
}();